import { Injectable } from '@angular/core';
import {Http, Headers} from '@angular/http';
import {Service} from "../shared/services/service";

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';
import { Observable } from 'rxjs/Rx';
import {Router} from "@angular/router";
import {TranslateService} from '@ngx-translate/core';
import {Funcoes} from "../funcoes";

declare let $:any;

@Injectable()
export class LoginService extends Service{

  protected url: string = this.dominio+'/pub/login/';
  public userInfo: any = {};
  protected logado = false;

  constructor(
    private router: Router,
    protected http: Http,
    private translate: TranslateService,
    protected func: Funcoes
  ){
    super();
    this.logado = !!localStorage.getItem('token');
  }

  login(email, senha) {

    let headers = new Headers();
    headers.append('Content-Type', 'application/json');

    return this.http
      .post(
        this.url,
        JSON.stringify({ email, senha }),
        { headers }
      )
      .map(res => {
        var json = res.json();
        if(json.Success){
          this.trataSucesso(res);
          this.logado = true;
        }else{
          this.trataErro(json);
          this.logado = false;
        }
        return json;
      });
  }

  sair() {
    let isAdm = this.func.getTokenInfo()['adm'];
    localStorage.removeItem('token');
    this.logado = false;
    if(isAdm == 1){
      this.router.navigate(['/login']);
    }else{
      this.router.navigate(['/login-cliente']);
    }
  }

  isLogado() {
    return this.logado;
  }


  getUserInfo(sync = false) {

      // se for syncrono retorna o objeto sem observer
      if(sync){
        return this.userInfo;
      }

      if(!this.func.isEmptyObject(this.userInfo)){
        return Observable.create(observer => {
          observer.next(this.userInfo);
          observer.complete();
        });
      }else{
        let userId = this.func.getTokenInfo()['uid'];
        let headers = this.getHeaderLogado();

        if(this.func.getTokenInfo()['adm'] == 1){
          return this.serverUserInfo();
        }else{
          return this.serverClienteInfo();
        }

        /*return this.http
          .get(
            this.dominio+'/adm/usuarios/'+userId,
            { headers }
          )
          .map(res => {
            let json = res.json();
            this.userInfo = json['Payload'][0];

            // atualiza idioma do usuario
            this.translate.use(this.userInfo.idioma);
            $.getScript("/assets/js/forms/pickadate-translations/"+this.userInfo.idioma+".js");

            return this.userInfo;
          });*/
      }
  }

  // busca e atualiza informações do usuario
  serverUserInfo(){

    let userId = this.func.getTokenInfo()['uid'];
    let headers = this.getHeaderLogado();

    return this.http
      .get(
        this.dominio+'/adm/usuarios/'+userId+'?relations=["privilegios","cargo"]',
        { headers }
      )
      .map(res => {
        let json = res.json();
        this.userInfo = json['Payload'][0];

        // atualiza idioma do usuario
        this.translate.use(this.userInfo.idioma);
        $.getScript("/assets/js/forms/pickadate-translations/"+this.userInfo.idioma+".js");

        return this.userInfo;
      });
  }

  loginCliente(email, senha) {

    let headers = new Headers();
    headers.append('Content-Type', 'application/json');

    return this.http
      .post(
        this.dominio+'/pub/login-cliente/',
        JSON.stringify({ email, senha }),
        { headers }
      )
      .map(res => {
        var json = res.json();
        if(json.Success){
          this.trataSucesso(res);
          this.logado = true;
        }else{
          this.trataErro(json);
          this.logado = false;
        }
        return json;
      });
  }

  serverClienteInfo(){

    let userId = this.func.getTokenInfo()['uid'];
    let headers = this.getHeaderLogado();

    return this.http
      .get(
        this.dominio+'/cli/clientes-usuarios/meus-dados/',
        { headers }
      )
      .map(res => {
        let json = res.json();

        this.userInfo = json['Payload'][0];

        // atualiza idioma do usuario
        this.translate.use(this.userInfo.idioma);
        $.getScript("/assets/js/forms/pickadate-translations/"+this.userInfo.idioma+".js");

        return this.userInfo;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/login/login.service.ts